module.exports = __webpack_public_path__ + "6a4ef177f281924b30fc121fff02a2bf.png";